<template>
	<div class="row box-style">
		<loading :active.sync="isLoading"></loading>
		<div class="col-12 p-0 p-b-5" v-if="status == 0 && (transaction.status == 'PendingApproval' || transaction.status == 'Pending')">
			<div class="col-12 p-2 ">
				<div>
					<strong>{{ t.transaction_approve_message }} </strong>
				</div>
				<div class="pt-2">
					<a class="mr-2 mb-2 btn btn-outline-success" v-on:click="setTransaction(1)"> {{ t.approve }}</a>
					<a class="mr-2 mb-2 btn btn-outline-danger" v-on:click="setTransaction(0)"> {{ t.cancel }}</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    export default {
        name: 'transactionManage',
	    props: {
            transaction: {

            }
	    },
        data () {
            return {
                t: this.$root.t,
	            isLoading: false,
	            status: 0
            }
        },
	    methods: {
            setTransaction(answer) {
                this.$http.get(api+'api/v1/user/transaction/order/approve', { params: {answer: answer, id: this.transaction.id} }).then(
                    response => {
                    // get body data
		                this.isLoading = false;
		                this.status = response.status;
		                swal(this.t.processing.success, this.t.processing.check, "success")

	            }, response => {
	                    this.isLoading = false;
	                    this.status = response.status;
	                    swal(this.t.processing.error, this.t.processing.check, "error")
	            })
            }
	    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/accounting/transactionManage.vue